import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://multi-counter.bancheng.tech/api';

/**
 * Get all languages
 */
export const getAllLanguages = async () => {
  try {
    const response = await axios.get(`${API_URL}/languages`);
    return response.data;
  } catch (error) {
    console.error('Error fetching languages:', error);
    throw error;
  }
};

/**
 * Get single language by ID
 */
export const getLanguage = async (languageId) => {
  try {
    const response = await axios.get(`${API_URL}/languages/${languageId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching language:', error);
    throw error;
  }
};

/**
 * Create new language
 */
export const createLanguage = async (languageData) => {
  try {
    const response = await axios.post(`${API_URL}/languages`, languageData);
    return response.data;
  } catch (error) {
    console.error('Error creating language:', error);
    throw error;
  }
};

/**
 * Update language
 */
export const updateLanguage = async (languageId, updates) => {
  try {
    const response = await axios.put(`${API_URL}/languages/${languageId}`, updates);
    return response.data;
  } catch (error) {
    console.error('Error updating language:', error);
    throw error;
  }
};

/**
 * Set language as default
 */
export const setDefaultLanguage = async (languageId) => {
  try {
    const response = await axios.put(`${API_URL}/languages/${languageId}/set-default`);
    return response.data;
  } catch (error) {
    console.error('Error setting default language:', error);
    throw error;
  }
};

/**
 * Delete language
 */
export const deleteLanguage = async (languageId) => {
  try {
    const response = await axios.delete(`${API_URL}/languages/${languageId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting language:', error);
    throw error;
  }
};
